import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable({
  providedIn: 'root',
})
export class ExcelFileDownloadServices {
  downloadExcel(fileArray: any) {
    console.log('ExcelArray', fileArray);

    const fileName = new Date().getTime() + '.xlsx';

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(fileArray);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');

    XLSX.writeFile(wb, fileName);

    // const workBook = XLSX.utils.book_new(); // create a new blank book

    // const workSheet = XLSX.utils.json_to_sheet(dataSheetJson, {
    //   header: [],
    //   skipHeader: false,
    // });
    // const workSheet1 = XLSX.utils.json_to_sheet(requestSheetJson, {
    //   header: [],
    //   skipHeader: false,
    // });

    // // ////console.log("EXCEL", exportJsonTemp);
    // XLSX.utils.book_append_sheet(workBook, workSheet, "DATA"); // add the worksheet to the book
    // XLSX.utils.book_append_sheet(workBook, workSheet1, "REPORT"); // add the worksheet to the book

    // XLSX.writeFile(workBook, "Car Request-" + new Date().getTime() + ".xlsx");
  }
}
